//@ts-ignore
global.PIXI   = require('phaser-ce/build/custom/pixi');
global.p2     = require('phaser-ce/build/custom/p2');
global.Phaser = require('phaser-ce');